import React from 'react';
import { Card, Row, Col, Image } from 'react-bootstrap';
import GroupImg from 'assets/img/about/group.jpeg';

const About = () => {
  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column">
        <Card.Title className="fs-6 fw-bold text-center text-lg-start">
          About
        </Card.Title>
        <Row className="w-100 mt-3 gx-4 d-flex align-items-center">
          <Col
            lg={4}
            xs={12}
            className="d-flex justify-content-center align-items-center"
          >
            <Image
              src={GroupImg}
              fluid
              className="rounded w-100 object-cover object-position-top max-h-250"
            />
          </Col>
          <Col lg={8} xs={12}>
            <p className="lh-35 text-muted text-center text-lg-start">
              At CRUDBeat, we empower students to excel in the competitive tech
              landscape. Our platform bridges the gap between talent and
              opportunity, connecting aspiring developers with top recruiters
              and organizations. With cutting-edge assessments, personalized
              skill-building tools, and a direct connection to hiring managers,
              CRUDBeat transforms the way students prepare for their careers.
              Whether you’re sharpening your skills or ready to land your dream
              job. Additionally, we offer students opportunities to participate
              in tech challenges, events, webinars, and workshops, enabling them
              to showcase their expertise, earn recognition, and enhance their
              learning experience.CRUDBeat is your trusted partner for success.
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default About;
